import { type UseQueryResult, useQuery } from 'react-query';
import {
  ParticipantBankService,
  // eslint-disable-next-line camelcase
  type Wealthlane_FinanceIntegrationService_Dtos_CompanyBank_ResponseCreateLinkToken,
} from '../../services/wealthlane-finance-integration-services';

const useGetCompanyBankToken = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_FinanceIntegrationService_Dtos_CompanyBank_ResponseCreateLinkToken | undefined,
  unknown
> => {
  const companyBankToken = useQuery(
    ['getCompanyBankToken'],
    async () => {
      return await handleRequest(
        ParticipantBankService.getApiFinanceIntegrationApiAppParticipantBankLinkToken()
      );
    },
    {
      refetchOnMount: false,
      refetchIntervalInBackground: false,
    }
  );

  return companyBankToken;
};

export default useGetCompanyBankToken;
